__turbopack_context__.v({
  "arrow": "index-module-scss-module__Ie5f0G__arrow",
  "barcode": "index-module-scss-module__Ie5f0G__barcode",
  "barcode-payment-card": "index-module-scss-module__Ie5f0G__barcode-payment-card",
  "card": "index-module-scss-module__Ie5f0G__card",
  "card-logo": "index-module-scss-module__Ie5f0G__card-logo",
  "card-name": "index-module-scss-module__Ie5f0G__card-name",
  "close": "index-module-scss-module__Ie5f0G__close",
  "code": "index-module-scss-module__Ie5f0G__code",
  "container": "index-module-scss-module__Ie5f0G__container",
  "content": "index-module-scss-module__Ie5f0G__content",
  "default-receipt-card": "index-module-scss-module__Ie5f0G__default-receipt-card",
  "hide": "index-module-scss-module__Ie5f0G__hide",
  "hint": "index-module-scss-module__Ie5f0G__hint",
  "loading-card": "index-module-scss-module__Ie5f0G__loading-card",
  "name": "index-module-scss-module__Ie5f0G__name",
  "qrcode": "index-module-scss-module__Ie5f0G__qrcode",
  "receipt-card": "index-module-scss-module__Ie5f0G__receipt-card",
  "success": "index-module-scss-module__Ie5f0G__success",
  "timer": "index-module-scss-module__Ie5f0G__timer",
  "title": "index-module-scss-module__Ie5f0G__title",
});
